import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * @author taulmax
 * @date 2024.10.19
 * @description 페이지 변경될 때마다 경로를 localStorage에 저장하기 위한 컴포넌트
 */
const SaveLastPath = () => {
  const location = useLocation();

  useEffect(() => {
    localStorage.setItem('lastPath', location.pathname + location.search);
  }, [location]);

  return null;
};

export default SaveLastPath;
